import React, { Fragment } from 'react';
import { VouchImg } from './CheckCode';
import styled from 'styled-components';
import VoucherCard from '../../images/voucher-card-old2.png';

const Wrap = styled.div`
  font-size: 20px;
  color: #434447;
  line-height: 35px;
  margin: 16px 0 16px 24px;
  text-align: left;
  ol {
    padding-left: 0;
  }
  li {
    font-weight: 600;
  }
  span {
    font-weight: 400;
  }
`;

export const ReceiptCode = () => (
  <Fragment>
    <VouchImg src={VoucherCard} />
    <Wrap>
      <ol>
        <li>
          <span>Locate the barcode at the bottom of your Bunnings receipt</span>
        </li>
        <li>
          <span>Look above the barcode to the right</span>
        </li>
        <li>
          <span>Your install code is the 20 digit number next to the #</span>
        </li>
      </ol>
    </Wrap>
  </Fragment>
);
